// created by gpake - Modified for web environment
import axios from 'axios';

var config = {
    qiniuRegion: '',
    qiniuImageURLPrefix: '',
    qiniuUploadToken: '',
    qiniuUploadTokenURL: '',
    qiniuUploadTokenFunction: null,
    qiniuShouldUseQiniuFileName: false
}

export default {
    init: init,
    upload: upload,
}

// 在整个程序生命周期中，只需要 init 一次即可
// 如果需要变更参数，再调用 init 即可
function init(options) {
    config = {
        qiniuRegion: '',
        qiniuImageURLPrefix: '',
        qiniuUploadToken: '',
        qiniuUploadTokenURL: '',
        qiniuUploadTokenFunction: null,
        qiniuShouldUseQiniuFileName: false
    };
    updateConfigWithOptions(options);
}

function updateConfigWithOptions(options) {
    if (options.region) {
        config.qiniuRegion = options.region;
    } else {
        console.error('qiniu uploader need your bucket region');
    }
    if (options.uptoken) {
        config.qiniuUploadToken = options.uptoken;
    } else if (options.uptokenURL) {
        config.qiniuUploadTokenURL = options.uptokenURL;
    } else if(options.uptokenFunc) {
        config.qiniuUploadTokenFunction = options.uptokenFunc;
    }
    if (options.domain) {
        config.qiniuImageURLPrefix = options.domain;
    }
    config.qiniuShouldUseQiniuFileName = options.shouldUseQiniuFileName
}

function upload(filePath, success, fail, options, progress, cancelTask, before, complete) {
    if (null == filePath) {
        console.error('qiniu uploader need filePath to upload');
        return;
    }
    if (options) {
      updateConfigWithOptions(options);
    }
    if (config.qiniuUploadToken) {
        doUpload(filePath, success, fail, options, progress, cancelTask, before, complete);
    } else if (config.qiniuUploadTokenURL) {
        getQiniuToken(function() {
            doUpload(filePath, success, fail, options, progress, cancelTask, before, complete);
        });
    } else if (config.qiniuUploadTokenFunction) {
        config.qiniuUploadToken = config.qiniuUploadTokenFunction();
        if (null == config.qiniuUploadToken && config.qiniuUploadToken.length > 0) {
            console.error('qiniu UploadTokenFunction result is null, please check the return value');
            return
        }
        doUpload(filePath, success, fail, options, progress, cancelTask, before, complete);
    } else {
        console.error('qiniu uploader need one of [uptoken, uptokenURL, uptokenFunc]');
        return;
    }
}

function doUpload(filePath, success, fail, options, progress, cancelTask, before, complete) {
    if (null == config.qiniuUploadToken && config.qiniuUploadToken.length > 0) {
        console.error('qiniu UploadToken is null, please check the init config or networking');
        return
    }
    var url = uploadURLFromRegionCode(config.qiniuRegion);
    var fileName = filePath.split('//')[1];
    
    // 修复文件名，添加文件扩展名
    if (filePath.indexOf('blob:') === 0) {
        // 从原始文件对象获取文件名和扩展名
        var fileExtension = '';
        var tempFileName = '';
        
        // 尝试从 filePath 中提取文件名
        try {
            // 创建一个临时的 URL 对象来解析 filePath
            var tempUrl = new URL(filePath);
            // 从 URL 的 search 参数中获取文件名信息
            var searchParams = new URLSearchParams(tempUrl.search);
            tempFileName = searchParams.get('name') || '';
        } catch (e) {
            console.error('解析文件路径失败:', e);
        }
        
        // 如果没有获取到文件名，生成一个随机文件名
        if (!tempFileName) {
            tempFileName = Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        }
        
        // 从原始文件对象获取扩展名
        // 注意：这里需要在调用 upload 方法时传递原始文件对象
        if (options && options.file) {
            var file = options.file;
            fileExtension = '.' + file.name.split('.').pop();
        }
        
        fileName = 'company/' + tempFileName + fileExtension;
    } else {
        // 处理普通文件路径
        if (fileName.includes('localhost:8084')) {
            fileName = fileName.replace('localhost:8084', 'company');
        }
    }
    
    if (options && options.key) {
        fileName = options.key;
    }
    
    // 使用 fetch 获取文件 Blob
    fetch(filePath)
        .then(res => res.blob())
        .then(blob => {
            var formData = new FormData();
            formData.append('token', config.qiniuUploadToken);
            formData.append('file', blob, fileName);
            if (!config.qiniuShouldUseQiniuFileName) {
                formData.append('key', fileName);
            }
            
            before && before();
            
            // 使用 axios 上传文件
            axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                    if (progress && progressEvent.total) {
                        progress({
                            progress: Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        });
                    }
                }
            })
            .then(res => {
                var dataObject = res.data;
                var fileUrl = config.qiniuImageURLPrefix + '/' + dataObject.key;
                dataObject.fileUrl = fileUrl;
                dataObject.imageURL = fileUrl;
                console.log(dataObject);
                if (success) {
                    success(dataObject);
                }
            })
            .catch(error => {
                console.error(error);
                if (fail) {
                    fail(error);
                }
            })
            .finally(() => {
                complete && complete();
            });
        })
        .catch(error => {
            console.error('Failed to fetch file:', error);
            if (fail) {
                fail(error);
            }
        });
}

function getQiniuToken(callback) {
    // 使用 axios 替代 wx.request
    axios.get(config.qiniuUploadTokenURL)
        .then(res => {
            var token = res.data.uptoken;
            if (token && token.length > 0) {
                config.qiniuUploadToken = token;
                if (callback) {
                    callback();
                }
            } else {
                console.error('qiniuUploader cannot get your token, please check the uptokenURL or server')
            }
        })
        .catch(error => {
            console.error('qiniu UploadToken is null, please check the init config or networking: ' + error);
        });
}

function uploadURLFromRegionCode(code) {
    var uploadURL = null;
    switch(code) {
        case 'CXC': uploadURL = 'https://up-z0.qiniup.com';break;
        case 'ECN': uploadURL = 'https://up.qiniup.com'; break;
        case 'NCN': uploadURL = 'https://up-z1.qiniup.com'; break;
        case 'SCN': uploadURL = 'https://up-z2.qiniup.com'; break;
        case 'NA': uploadURL = 'https://up-na0.qiniup.com'; break;
        case 'ASG': uploadURL = 'https://up-as0.qiniup.com'; break;
        default: console.error('please make the region is with one of [ECN, SCN, NCN, NA, ASG]');
    }
    return uploadURL;
}